<template>
    <div>
        <van-form @submit="onSubmit">
            <van-field v-model="form.project_name" label="项目名称" placeholder="请填写"/>
            <van-field v-model="form.role_name" label="担任角色" placeholder="请填写"/>
            <div class="way plc plcgo">
                <van-field
                    readonly
                    clickable
                    label="时间段"
                    :value="form.date"
                    placeholder="选择时间段"
                    @click="timePicker = true"
                />
                <van-popup v-model="timePicker" position="bottom">
                    <time-date
                        show-toolbar
                        v-model="currentDate"
                        :min-date="minDate"
                        :max-date="maxDate"
                        @cancel="timePicker = false"
                        @confirm="timeConfirm"
                    >
                    </time-date>
                </van-popup>
                <img :src="require('@/assets/img/go.png')" alt="">
            </div> 
            <van-field v-model="form.work_result" rows="2" autosize label="工作成果" type="textarea" placeholder="请填写工作成果"/>
            <div class="pic">
                <span>项目图片</span>
                <van-uploader v-model="fileList" :after-read="afterRead" :before-delete="deleteImg"/>
            </div>
            <div style="margin: 16px;">
                <van-button round block type="danger" native-type="submit">下一步</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import { Toast } from 'vant';
import { editProjectApi, getProjectExpById } from '@/api/interview'
import TimeDate from '@/components/TimeDate'
import axios from 'axios'
    export default {
         data() {
            return {
                form:{
                    show_images:[]
                },
                timePicker:false, //时间选择器
                minDate: new Date(1900, 5, 15),
                maxDate: new Date(),
                currentDate: new Date(),
                startDate: '',
                endDate: '',
                fileList:[],
                id:sessionStorage.getItem("ID") || 0,
            };
        },
        mounted(){
            this.getProjectExpById()
        },
        methods: {
            // 详情
            getProjectExpById(){
                getProjectExpById({id: this.$route.query.id}).then(res=>{
                    if(res.errNo == 0){
                        this.form = res.result
                        this.form.show_images = JSON.parse(res.result.show_images)
                        if(res.result.start_date&&res.result.end_date){
                            this.form.date = res.result.start_date + '-' + res.result.end_date
                            this.form.start_date=res.result.start_date
                            this.form.end_date=res.result.end_date
                        }
                        if(this.form.show_images.length > 0){
                            this.form.show_images.forEach(res=>{
                                this.fileList.push({url: res})
                            })
                        }
                    }
                })
            },
            onSubmit() {
                console.log(this.form,'this.form----------')
                if(JSON.stringify(this.form)==='{"show_images":[]}'){
                    this.$router.push({path:"/interviews/resume"})
                    return
                }
                // 下方时间+字符串'-01'是用来方便后端数据处理
                if(this.form.start_date){
                    this.form.start_date = this.form.start_date+'-01'
                    this.form.end_date = this.form.end_date+'-01'
                }
                const params = {
                    resume_id:this.id,
                    ...this.form,
                    show_images:JSON.stringify(this.form.show_images)
                }
                editProjectApi(params).then(res=>{
                    if(res.errNo===0){
                         this.$router.push({path:"/interviews/projectlist"})
                    } else {
                        Toast('提交失败,请检查填写信息');
                    }
                })
            },
            // 时间段选择器
            timeConfirm(value, index) {
                this.startDate = value.slice(0,2).join('-');
                this.endDate = value.slice(3,6).join('-');
                this.form.date = this.startDate + '-' + this.endDate;
                this.form.start_date=this.startDate
                this.form.end_date=this.endDate
                this.timePicker = false
            },
            // 图片上传
            afterRead(file) {
            //此时可以自行将文件上传至服务器
                var formData = new FormData();
                formData.append('pic',file.file)
                axios.post('https://f.zhulong.com/uploadZhulongImgForEdit.php',formData).then(res=>{
                    console.log(res)
                    if(res.status===200){
                        this.form.show_images.push(res.data.url)
                    }
                })
            },
            // 图片删除
            deleteImg(file,detail){
                this.form.show_images.splice(detail.index,1)
                this.fileList.splice(detail.index,1)
            }
        },
        components:{
            TimeDate
        }
    }
</script>

<style scoped lang="less">
/deep/ .van-uploader__upload {
  width: 100px;
  height: 100px;
}
.pic {
    padding: 30px 4.2% 0;
    display: flex;
    align-items: center;
    span {
        color: #646566;
        font-size: 26px;
        padding-right: 30px;
    }
}
/deep/ .van-cell {
  display: block;
}
/deep/ .van-field__error-message {
  text-align: center;
}
/deep/ .van-cell::after {
  border-bottom: 1px solid #999999;
}
.plc {
    position: relative;
    &::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 30px;
    bottom: 0;
    left: 30px;
    border-bottom: 1px solid #999999;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}

.plcgo {
    img {
        width: 18px;
        height: 31px;
        position: absolute;
        right: 30px;
        top: 54px;
    }
}
/deep/ .van-image{
    width: 100px;
    height: 100px;
    img{
        border-radius: 50%;
    }
}
/deep/ .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
/deep/ .van-button--block {
  border-radius: 10px;
}
</style>